import { LoginResponseDto } from '@/api/generated';
import {
  AuthenticationDataContext,
  AuthenticationDataContextProps,
} from '@/utils/providers/authetnitactionDataContext/AuthenticationDataContext.tsx';
import React, { PropsWithChildren, useMemo, useState } from 'react';

export const AuthenticationDataProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [authenticationData, setAuthenticationData] = useState<LoginResponseDto | null>(null);

  const context: AuthenticationDataContextProps = useMemo(() => {
    return {
      authenticationData,
      setAuthenticationData,
    };
  }, [authenticationData]);

  return (
    <AuthenticationDataContext.Provider value={context}>
      {children}
    </AuthenticationDataContext.Provider>
  );
};
